module.exports = __webpack_public_path__ + "img/children-2.24a8493c.jpg";